import { BrowserRouter, useRoutes } from 'react-router-dom';
import { ApiCacheFallbackNotice } from './components/ApiCacheFallbackNotice';
import { OnboardingModal } from './components/OnboardingModal';
import { SignupSurveyModal } from './components/SignupSurveyModal';
import { SubscriptionExpiryToast } from './components/SubscriptionExpiryToast';
import { ConfirmDialog, Toast } from './components/ui';
import { AuthProvider, FinanceProvider, PreferencesProvider } from './contexts';
import { routes } from './routes';
import './styles/global.css';

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  return (
    <BrowserRouter>
      <PreferencesProvider>
        <AuthProvider>
          <FinanceProvider>
            <AppRoutes />
            <SignupSurveyModal />
            <OnboardingModal />
            <SubscriptionExpiryToast />
            <ApiCacheFallbackNotice />
            <Toast />
            <ConfirmDialog />
          </FinanceProvider>
        </AuthProvider>
      </PreferencesProvider>
    </BrowserRouter>
  );
}

export default App;